import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "button-content ellipsis-3-lines" }
const _hoisted_2 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    color: "primary",
    "text-color": "white",
    disable: _ctx.disabled,
    onClick: _ctx.emitClick,
    class: "h-radius"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _withDirectives(_createVNode(_component_q_icon, {
          name: _ctx.leftIcon,
          class: "q-mr-sm"
        }, null, 8, ["name"]), [
          [_vShow, _ctx.leftIcon]
        ]),
        _createElementVNode("div", {
          textContent: _toDisplayString(_ctx.button.text)
        }, null, 8, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["disable", "onClick"]))
}